import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  /* visibility: BehaviorSubject<boolean>;
 
  constructor() {
    this.visibility = new BehaviorSubject(false);
  }
 
  show() {
    this.visibility.next(true);
  }
 
  hide() {
    this.visibility.next(false);
  } */

  public isLoading = new BehaviorSubject(false);
  checkInternet = new BehaviorSubject<boolean>(true);
  checkInternetObs = this.checkInternet.asObservable();
  
  constructor() { }

  internetUpdate(internet: boolean) {
    this.checkInternet.next(internet);
  }
}
